<div class="w-100">
  <h2 class="mb-5">Projects</h2>

  <div
    class="resume-item d-flex flex-column flex-md-row justify-content-between mb-2"
  >
    <div class="resume-content">
      <mat-accordion>
        <mat-expansion-panel
          (opened)="panelOpenState = true"
          (closed)="panelOpenState = false"
          *ngFor="let project of projectList"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="resume-content">{{ project.Name }}</div>
            </mat-panel-title>

            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>
          <hr />

          <div class="resume-date">
            <span ><strong>Year: </strong> {{ project.Year }}</span>
          </div>
          <br>
          <div class="resume-content">
            <span ><strong>Description: </strong>{{ project.Description }}</span>            
            <br>
            <br>
            <mat-chip-list *ngIf="project.Technologies.length>0">
              <span><strong>Techologies: </strong></span>
              <div *ngFor="let Tech of project.Technologies">
                <mat-chip color="primary">{{ Tech }}</mat-chip>
              </div>
            </mat-chip-list>
          </div>
        
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
